/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './recordWithMedia.defs'
export { main as default } from './recordWithMedia.defs'
